import { MenuItem } from 'types/otkTypes';
import { PngItem } from './PngItem';

export const renderMenuItem = (...params:any ) => {
  const data:MenuItem = params?.[0];
  return <PngItem item={data} />;
};
